import { useCallback } from "react";
import { type Control, useFieldArray } from "react-hook-form";
import { DEFAULT_TOR_RULE, MAX_TOR_RULES } from "./constants";
import type { TorRulesFormValues } from "./types";

type UseTorRulesFieldArrayProps = {
  control: Control<TorRulesFormValues>;
  maxRules?: number;
};

export const useTorRulesFieldArray = (props: UseTorRulesFieldArrayProps) => {
  const { control, maxRules = MAX_TOR_RULES } = props;

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "torRules",
  });

  const addRule = useCallback(() => {
    if (fields.length >= maxRules) return;
    append(DEFAULT_TOR_RULE);
  }, [append, fields.length, maxRules]);

  const removeRule = useCallback(
    (index: number) => {
      if (fields.length <= 1) return;
      remove(index);
    },
    [fields.length, remove],
  );

  return {
    fields,
    addRule,
    removeRule,
    replace,
    canAddRule: fields.length < maxRules,
    canRemoveRule: fields.length > 1,
  };
};
